import DetailsIcon from '@mui/icons-material/Info';
import { FC } from 'react';
import { NumberField, SelectField } from 'react-admin';

import { ContractFeeChargeOne } from '@Common/types/bo/b2b/contract_fee_charges';

import {
  contractFeeChargesFeeLabelChoices,
  contractFeeChargesPaidByChoices,
  ShowFields,
  ShowSection,
  ShowWithNavigation,
  VerticalTab,
  VerticalTabsLayout,
} from '@sh4res/bo-common/components';
import { CurrencyField, IdField, UTCDateField } from '@sh4res/bo-common/fields';

export const ContractFeeChargesShow: FC = () => {
  const testId = 'BoExternalContractFeeChargesShow';
  return (
    <ShowWithNavigation actions={false} sx={{ height: '100%' }} navigateTo={() => -1}>
      <VerticalTabsLayout>
        <VerticalTab
          icon={<DetailsIcon />}
          label="resources.bo_common.b2b.contract_fee_charges.sections.details"
          path="details">
          <ShowSection label="general.sections.details">
            <ShowFields<ContractFeeChargeOne>
              fields={{
                id: <IdField reference="contract_fee_charges" data-testid={`${testId}_IdField`} />,
                paid_by: (
                  <SelectField
                    choices={contractFeeChargesPaidByChoices}
                    data-testid={`${testId}_PaidByField`}
                  />
                ),
                b2b_company_id: (
                  <IdField reference="companies" data-testid={`${testId}_CompanyIdField`} />
                ),
                b2b_contract_id: (
                  <IdField reference="contracts" data-testid={`${testId}_ContractIdField`} />
                ),
                b2b_contract_version_num: (
                  <NumberField data-testid={`${testId}_ContractVersionNumField`} />
                ),
                fee_label: (
                  <SelectField
                    choices={contractFeeChargesFeeLabelChoices}
                    data-testid={`${testId}_FeeLabelField`}
                  />
                ),
                amount: <CurrencyField currency="EUR" data-testid={`${testId}_AmountField`} />,
                created_at: <UTCDateField data-testid={`${testId}_CreatedAtField`} />,
                updated_at: <UTCDateField data-testid={`${testId}_UpdatedAtField`} />,
              }}
            />
          </ShowSection>
        </VerticalTab>
      </VerticalTabsLayout>
    </ShowWithNavigation>
  );
};
